import { LocalizedLink } from "@/i18n/language";
import { useTranslation } from "react-i18next";
import { img } from "@/lib/images";

const stayImg = img("home/home-stay-01.jpg");

const exploreImg = img("home/home-explore-01.jpg");

const celebrateImg = img("home/home-celebrate-01.jpg");

function PillarContent({
  labelKey,
  subKey,
  descKey,
  ctaKey,
  to,
}: {
  labelKey: string;
  subKey: string;
  descKey: string;
  ctaKey: string;
  to: string;
}) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="eyebrow-brand text-sm md:text-base uppercase tracking-[0.35em] mb-3">
        {t(labelKey)}
      </div>
      <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 leading-[1.15] tracking-tight">
        {t(subKey)}
      </h3>
      <p className="mt-4 text-foreground-600 leading-relaxed whitespace-pre-line text-base md:text-lg">
        {t(descKey)}
      </p>
      <LocalizedLink
        to={to}
        className="mt-7 inline-flex items-center gap-2 text-accent-700 font-semibold uppercase tracking-wider text-sm group cursor-pointer"
      >
        {t(ctaKey)}
        <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
      </LocalizedLink>
    </div>
  );
}

export default function ThreePillars() {
  const { t } = useTranslation();

  return (
    <section className="pt-10 md:pt-12 pb-10 md:pb-12 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-9 md:mb-12">
          <div className="eyebrow-brand text-sm md:text-base uppercase tracking-[0.35em] mb-3">
            — {t("pillars_eyebrow")} —
          </div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.1] tracking-tight mb-4">
            {t("pillars_title")}
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            {t("pillars_sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          <article>
            <div className="relative rounded-lg overflow-hidden aspect-[4/5]">
              <img
                src={exploreImg}
                alt={t("pillar_explore_sub")}
                title={`Bali VW Tour – ${t("pillar_explore_sub")}`}
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="mt-8">
              <PillarContent
                labelKey="pillar_explore_label"
                subKey="pillar_explore_sub"
                descKey="pillar_explore_desc"
                ctaKey="pillar_explore_cta"
                to="/activities"
              />
            </div>
          </article>

          <article>
            <div className="relative rounded-lg overflow-hidden aspect-[4/5]">
              <img
                src={stayImg}
                alt={t("pillar_stay_sub")}
                title={`Bali VW Tour – ${t("pillar_stay_sub")}`}
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="mt-8">
              <PillarContent
                labelKey="pillar_stay_label"
                subKey="pillar_stay_sub"
                descKey="pillar_stay_desc"
                ctaKey="pillar_stay_cta"
                to="/villas"
              />
            </div>
          </article>

          <article>
            <div className="relative rounded-lg overflow-hidden aspect-[4/5]">
              <img
                src={celebrateImg}
                alt={t("celebrate_img_alt")}
                title={t("celebrate_img_title")}
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="mt-8">
              <PillarContent
                labelKey="pillar_celebrate_label"
                subKey="pillar_celebrate_sub"
                descKey="pillar_celebrate_desc"
                ctaKey="pillar_celebrate_cta"
                to="/weddings"
              />
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}